const API_URL = 'https://app2.greenfee-deals.de';
// const API_URL = 'http://localhost:5000';
export default {
  API_URL,
};
